import Entity from "../../../class/abstract/Entity";
import Store from "../../_account/Stores/Store";
import ManualDrawerLicense from "./ManualDrawerLicense";

class ManualDrawer extends Entity {
    name = null;
    reference = null;
    target = null;
    interfaceType = null;
    brand = null;
    model = null;
    serialPort = null;
    serialBaudRate = null;
    serialDataBits = null;
    serialParity = null;
    serialStopBits = null;
    serialFlowControl = null;
    active = null;
    store_id = null;
    store = {};
    last_histo_author = null;
    licenses = [];
    licensesString = "";
    brandResume = "";
    connectionResume = "";

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";
        let exceptKeys = ["licenses"];

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined && !exceptKeys.includes(key)) {
                if(key === "store")
                    Reflect.set(this, key, new Store(datas[key]));
                else
                    Reflect.set(this, key, datas[key]);
            }
        }

        if (datas.licenses !== undefined) {
            this.licenses = [];

            for (let item in datas.licenses)
                this.licenses.push(new ManualDrawerLicense(datas.licenses[item]));
        }

        this.defineBrandResume();
        this.defineConnectionResume();
        //this.defineLicenseString();
    }
    defineBrandResume() {
        if (this.brand === null || this.model === null)
            return;

        this.brandResume = this.brand + " - " + this.model;
    }
    defineConnectionResume() {
        if (this.interfaceType === null)
            return;

        switch (this.interfaceType.toLowerCase()) {
            case "serial":
                this.connectionResume = "SERIE - COM " + this.serialPort;
                break;
            case "ip":
                this.connectionResume = "IP - " + this.ipAddress + " - port " + this.ipPort;
                break;
            case "usb":
                this.connectionResume = "USB - port " + this.usbPort;
                break;
            default: break;
        }
    }
    defineLicenseString() {
        if (this.licenses.length === 0)
            this.licensesString = "Aucune"
        else {
            for (let i in this.licenses) {
                if (this.licensesString.length > 0)
                    this.licensesString += ", "

                this.licensesString += this.licenses[i].name
            }
        }
    }
}

export default ManualDrawer;
